module.exports = __webpack_public_path__ + "static/media/processing.f791ed87.svg";